import ScrollIndicator from "./indicator";
import TableWrapper from "./table-wrapper";
import ScrollPositionPreference from "./scroll-position-preference";
var CONST = {
    BODY_CLASS: 'acp-overflow-table'
};
var HorizontalScrolling = /** @class */ (function () {
    function HorizontalScrolling(table) {
        this.enabled = document.body.classList.contains(CONST.BODY_CLASS);
        this.table = table;
        this.wrapper = new TableWrapper(this.table);
        this.indicator = new ScrollIndicator(this.table, this.wrapper);
        this.scrollPreference = new ScrollPositionPreference(this);
        if (this.isEnabled()) {
            this.wrapper.wrap();
            this.wrapper.enable();
            if (ACP_Horizontal_Scrolling.hasOwnProperty('indicator_enabled') && ACP_Horizontal_Scrolling.indicator_enabled) {
                this.indicator.enable();
            }
        }
    }
    HorizontalScrolling.prototype.isEnabled = function () {
        return this.enabled;
    };
    HorizontalScrolling.prototype.enable = function () {
        document.body.classList.add(CONST.BODY_CLASS);
        this.enabled = true;
        this.wrapper.wrap();
        this.wrapper.enable();
        this.wrapper.checkWrapperState();
        this.indicator.enable();
    };
    HorizontalScrolling.prototype.disable = function () {
        this.wrapper.disable();
        this.enabled = false;
        this.indicator.disable();
        document.body.classList.remove(CONST.BODY_CLASS);
    };
    HorizontalScrolling.prototype.getScrollLeft = function () {
        return this.table.scrollLeft;
    };
    HorizontalScrolling.prototype.setScrollLeft = function (offset) {
        this.table.scrollLeft = offset;
    };
    HorizontalScrolling.prototype.store = function () {
        jQuery.post(ajaxurl, {
            action: 'acp_update_table_option_overflow',
            value: this.isEnabled(),
            layout: AC.layout,
            list_screen: AC.list_screen,
            _ajax_nonce: AC.ajax_nonce
        });
    };
    return HorizontalScrolling;
}());
export default HorizontalScrolling;
